import { useState, useCallback } from "react";
import { X } from "lucide-react";
import type { Holiday } from "@/config/holidays";

const STORAGE_KEY = "holiday-banner-dismissed";

function isDismissed(holidayId: string): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === holidayId;
  } catch {
    return false;
  }
}

function dismiss(holidayId: string) {
  try {
    sessionStorage.setItem(STORAGE_KEY, holidayId);
  } catch {
    // ignore
  }
}

export function HolidayBanner({ holiday }: { holiday: Holiday }) {
  const [visible, setVisible] = useState(() => !isDismissed(holiday.id));

  const handleDismiss = useCallback(() => {
    dismiss(holiday.id);
    setVisible(false);
  }, [holiday.id]);

  if (!visible) return null;

  return (
    <div className="relative mb-4 overflow-hidden rounded-lg border bg-card px-4 py-3 text-center text-sm font-medium shadow-sm">
      <div className="holiday-banner-shimmer" />
      <span className="relative z-10">{holiday.greeting}</span>
      <button
        onClick={handleDismiss}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-1 text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Uždaryti"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
